import { Component, OnInit, Type } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { AuthService } from "../services/auth/auth.service";
import { ToastrService } from "ngx-toastr";
import { MessageUtil } from "../utils/message.util";
import { environment } from "src/environments/environment";
import { Login } from "../models/login";
import { LoginResponse } from "../models/login-response";
import { SiteService } from "src/app/services/site/site.service";
import { Site } from "src/app/models/site";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  formGroup: FormGroup;
  baseCss: string;
  curso: string;
  login = new Login();
  layout = new Site();

  constructor(
    private router: Router,
    public formBuilder: FormBuilder,
    private authService: AuthService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private siteService: SiteService,
    private titleService: Title
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.curso = params.source || environment.medAulaId;
    });

    this.trocaLayout();

    this.formGroup = this.formBuilder.group({
      email: ["", [Validators.required]],
      senha: ["", [Validators.required]],
    });
  }

  async trocaLayout() {
    this.blockUI.start(MessageUtil.AGUARDE);
    let corPrincipal = "";
    const botao = document.getElementById("submit");
    const svgColor = document.getElementById("svgColor");

    let currSource = environment.medAulaId;
    if (currSource === null) {
      currSource = localStorage.getItem("source");
    }

    if (currSource === null) {
      environment.medAulaId = "1";
      localStorage.setItem("source", "1");
      corPrincipal = "#f14a43";
      botao.style.backgroundColor = corPrincipal;
      svgColor.style.fill = corPrincipal;
    } else {
      await this.siteService.getSiteLayout(environment.medAulaId).subscribe(
        (layout) => {
          this.layout = layout;
          corPrincipal = this.layout.corPrincipal;
          botao.style.backgroundColor = corPrincipal;
          svgColor.style.fill = corPrincipal;
          this.titleService.setTitle(this.layout.nome + " - Login");
        },
        () => this.blockUI.stop()
      );
    }
    this.blockUI.stop();
  }

  onLogin() {
    if (this.formGroup.invalid) {
      this.toastr.error(MessageUtil.PREENCHA_CAMPOS_OBRIGATORIOS);
      return;
    }

    this.blockUI.start(MessageUtil.AGUARDE);
    this.authService.login(this.login).subscribe(
      (loginResponse) => this.afterLogin(loginResponse),
      (err) => this.onLoginError(err)
    );
  }

  afterLogin(loginResponse: LoginResponse) {
    this.blockUI.stop();
    this.setLocalStorage(loginResponse);

    const trial = 0;
    const singlePlan = 1;
    const manyPlans = "manyPlans";

    // const loginOptions = new Map()
    //   .set(trial, () => this.navegarPaginaTrial())
    //   .set(singlePlan, () => this.navegarPaginaAulas(loginResponse))
    //   .set(manyPlans, () => this.navegarPaginaSelecaoPlanos());

    // const selectedOption =
    //   loginOptions.get(loginResponse.planos.length) ||
    //   loginOptions.get(manyPlans);
    // selectedOption();

    this.navegarPaginaTrial();
  }

  private onLoginError(err: any) {
    this.blockUI.stop();
    this.toastr.error(
      (err.error && err.error.message) || "Usuário ou senha inválidos!"
    );
  }

  navegarPaginaTrial() {
    localStorage.setItem("cursoTrial", JSON.stringify({ id: this.curso }));
    this.router.navigate(["/plataforma-trial"]);
  }

  navegarPaginaAulas(loginResponse) {
    localStorage.setItem(
      "planoSelecionado",
      JSON.stringify(loginResponse.planos[0])
    );
    this.router.navigate(["/aulas"]);
  }

  navegarPaginaSelecaoPlanos() {
    this.router.navigate(["/selecao-planos"]);
  }

  setLocalStorage(result: any) {
    localStorage.setItem("isLoggedin", "true");
    localStorage.setItem("token", result.token);
    localStorage.setItem("refreshToken", result.refreshToken);
    localStorage.setItem("planos", JSON.stringify(result.planos));
  }
}
